/* eslint-disable import/prefer-default-export */

export const wrapPageElement = ({ element }) => element;
